import { atom } from 'jotai';

export const aiBotUpgradeModalOpenAtom = atom<{
  open: boolean;
  step: number;
}>({
  open: false,
  step: 0,
});

export const facebookCapiUpgradeModalOpenAtom = atom(false);
